import type { ReactNode } from 'react'

/**
 * Paylaşılan **bölüm kartı** (Reuse Mandate). Pano/dashboard ekranlarında bir bölümü (başlık + isteğe
 * bağlı sağ üst ipucu + gövde + isteğe bağlı alt aksiyon) kutular.
 *
 * Anayasanın **yüzen tek kart kabuğu** kuralı korunur: bu bileşen kabuğu değiştirmez, içerik kartının
 * İÇİNDE bölümleme yapar. Görünüm mevcut kart dilinden (`--card-border`, `--r-lg`, hafif gölge) gelir;
 * yeni kart stili icat edilmez. Başlık `h2`dir (sayfa `h1`i altında doğru hiyerarşi).
 */
export interface SectionCardProps {
  title: string
  /** Sağ üstte küçük ipucu/etiket — ör. sıralama ölçütü ("geciken ↓"). */
  hint?: ReactNode
  /** Kartın altındaki aksiyon/bağlantı satırı. */
  footer?: ReactNode
  children: ReactNode
  className?: string
}

export default function SectionCard({
  title,
  hint,
  footer,
  children,
  className,
}: Readonly<SectionCardProps>) {
  return (
    <section className={`ui-section${className ? ` ${className}` : ''}`}>
      <header className="ui-section-head">
        <h2 className="ui-section-title">{title}</h2>
        {hint != null && <span className="ui-section-hint">{hint}</span>}
      </header>
      <div className="ui-section-body">{children}</div>
      {footer != null && <div className="ui-section-foot">{footer}</div>}
    </section>
  )
}
